import { gql } from "@outschool/ui-apollo";

export const enrolledClassesQuery = gql`
  query EnrolledClassesQuery(
    $start: DateTime!
    $end: DateTime!
    $page: Int!
    $limit: Int!
    $learnerUid: ID
  ) {
    currentUser {
      uid
      paginatedActiveEnrollments(
        start: $start
        end: $end
        page: $page
        limit: $limit
        learnerUid: $learnerUid
      ) {
        results {
          uid
          thisWeekPauseDeadline
          canBeStopped
          canBePaused
          canBeWithdrawn
          isEnded
          isPaused
          ongoingStartTime
          ongoingEndTime
          refundableAmountCents
          confirmedAt
          withdrawn_at
          withdrawnAt
          price_cents
          priceCredits
          buyer {
            uid
            name
          }
          details {
            name
          }
          learner {
            uid
            name
            avatar
          }
          parent {
            uid
            name
          }
          payments {
            uid
            isOngoingRefundable
            paid_at
            unrefundedCents
            end_time
            service_fee_percentage
            credit_transaction_uid
            credit_account_type
          }
          paymentSchedule {
            uid
            stoppedAt
          }
          pauseWindow {
            uid
            startDate
            endDate
            canBeCanceled
            pauseReason
          }
          upcomingPausedMeeting {
            uid
            start_time
            end_time
          }
          refundPolicy {
            name
            description
          }
          service_fee_percentage
          section {
            uid
            canceled_at
            deleted_at
            end_time
            is_self_paced
            price_cents
            priceCredits
            published_at
            start_time
            isBuyable
            meetingTimes {
              dayOfWeek
              hour
              minute
            }
            activity {
              uid
              duration_weeks
              duration_minutes
              size_max
              hasTeacherSchedule
              isClub
              isOneTime
              is_ongoing_weekly
              price_cents
              priceCredits
              published_at
              title
              titleTranslated
              weekly_meetings
              subject
              averageStarRating
              reviewCount
              age_min
              age_max
              hasTeacherSchedule
              isFlexSchedule
              isSelfPaced
              details {
                photo
              }
              leader {
                uid
                name
                photo
                leader_link
                timeZone
              }
            }
            leader {
              uid
              name
              photo
              leader_link
              timeZone
            }
            meetings(filter: Enrolled, startAfter: $start, limit: 5) {
              uid
              start_time
              end_time
            }
            nextOngoingMeeting {
              uid
              start_time
              end_time
            }
          }
        }
        pageInfo {
          currentPage
          totalPages
          totalItems
        }
      }
    }
  }
`;
